<template>
  <div class="header_container">
    <div class="header_wrap">
      <div class="header_left">
        <div class="icon1">
          <img src="@/assets/img/top/titleicon1.png" alt="" />
        </div>
        <div class="icon2">
          <img src="@/assets/img/top/titleicon2.png" alt="" />
        </div>
      </div>
      <div class="header_right">
        <!-- <div class="drops_info" @click="jumpToUrl">
          <div class="drops_line"></div>
          <img src="@/assets/img/drops_icon.png" alt="" />
          <div class="title">NFT Drops</div>
          <div class="drops_line"></div>
        </div> -->
        <div class="drops_info" @click="jumpToUrl('https://mg.miracles.games')">
          <div class="drops_line"></div>
          <img src="@/assets/img/ICON_PLAY_NOW.png" alt="" />
          <div class="title">PLAY NOW</div>
          <!-- <div class="drops_line"></div> -->
        </div>
        <div class="drops_info" @click="jumpToUrl('https://market.miracles.games')">
          <div class="drops_line"></div>
          <img src="@/assets/img/ICON_NFT_MARKET.png" alt="" />
          <div class="title">NFT MARKET</div>
          <div class="drops_line"></div>
        </div>
        <template>
          <el-dropdown v-if="type !== 'mobile'" trigger="click">
            <div class="header_chain">
              <samp>BSC</samp>
              <img class="icon" src="@/assets/img/public/icon_arrow_down.png" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><span>BSC</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <div class="header_address" v-if="fromAddress">
          <el-dropdown trigger="click">
            <div class="header_address_con">
              <samp>{{ fromAddress }}</samp>
              <img class="icon" src="@/assets/img/public/icon_arrow_down.png" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><span @click="onLogout">Logout</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="header_login_mobile" v-if="type === 'mobile' && !fromAddress" @click="showDialog">Wallte</div>
        <div class="header_login" v-else-if="!fromAddress" @click="showDialog">Connect Wallet</div>
      </div>
    </div>
    <dialog-login :visible="visible" @hideDialog="hideDialog" @getMetaMaskTrade="getMetaMaskTrade" />
    <MetaMaskTrade ref="metaMask" />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import DialogLogin from '../../components/dialog-login';
import MetaMaskTrade from '../../components/metaMask-trade';
import { logOut} from '../../assets/api/public';

// const DROPS_URL = 'https://airdrop.miracles.games/'

export default {
  name: "Head",
  components: {
    DialogLogin,
    MetaMaskTrade
  },
  props: {
    type: {
      type: String,
      default: 'computer'
    }
  },
  data() {
    return {
      navHide: true,
      visible: false
    };
  },
  computed: {
    ...mapState(['fromAddress'])
  },
  async mounted() {
    let fromAddress = await this.$refs.metaMask.getAccounts();
    let token = localStorage.getItem('token');
    if (!token) return;
    this.setFromAddress(fromAddress);
  },
  methods: {
    ...mapMutations(['setFromAddress', 'setIsLogin']),
    hideDialog() {
      this.visible = false;
    },
    showDialog() {
      this.visible = true;
    },
    jumpToUrl(url){
      if(this.type === 'mobile'){
        window.open(url, '_self');
      }else{
        window.open(url, '_blank');
      }
    },
    // call MetaMsk
    getMetaMaskTrade() {
      this.$refs.metaMask.init((fromAddress, balance, switchover) => {
        if (switchover) {
          logOut(this);
        }
        this.setFromAddress(fromAddress);
        this.setIsLogin(true);
        this.hideDialog();
      });
    },
    onLogout() {
      logOut(this);
    }
  }
};
</script>
<style scoped lang="scss">
.header_wrap {
  .header_left{
    .icon1 {
      padding-left: 25px;
      img {
        width: 40px;
        height: 46px;
      }
    }
    .icon2 {
      padding-left: 26px;
      img {
        width: 262px;
        height: 46px;
      }
    }
  }
}

@media (max-width: 1199px) {
  .header_wrap {
    .header_left{
      .icon1 {
        padding-left: 0.186667rem;
        img {
          width: 0.373333rem;
          height: 0.426667rem;
        }
      }
      .icon2 {
        padding-left: 0.2rem;
        img {
          width: 2.453333rem;
          height: 0.453333rem;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .header_wrap {
    .header_left{
      .icon1 {
        padding-left: 0.186667rem;
        img {
          width: 0.373333rem;
          height: 0.426667rem;
        }
      }
      .icon2 {
        padding-left: 0.2rem;
        img {
          width: 2.453333rem;
          height: 0.453333rem;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .header_wrap {
    .header_left{
      .icon1 {
        padding-left: 0.186667rem;
        img {
          width: 0.373333rem;
          height: 0.426667rem;
        }
      }
      .icon2 {
        padding-left: 0.2rem;
        img {
          width: 2.453333rem;
          height: 0.453333rem;
        }
      }
    }
  }
}
</style>
